import React from "react";

export interface DiagnosisTileProps {
  /** Number of rules that fired (triggered). */
  firedCount: number;
  /** Total number of rules (e.g. 5). */
  totalRules?: number;
  /** Short body sentence; can include <b> for emphasis. */
  body: React.ReactNode;
  /** Rule labels that fired (red). */
  firedRules: string[];
  /** Rule labels that did not fire (quiet, checkmark style). */
  quietRules: string[];
}

export function DiagnosisTile({
  firedCount,
  totalRules = 5,
  body,
  firedRules,
  quietRules,
}: DiagnosisTileProps) {
  return (
    <div className="diagnosis">
      <div className="diag-icon" aria-hidden>!</div>
      <div>
        <div className="diag-title">
          Diagnosis · {firedCount} of {totalRules} rules triggered
        </div>
        <div className="diag-body">{body}</div>
        <div className="diag-rules">
          {firedRules.map((label) => (
            <span key={label} className="fired">
              ● {label}
            </span>
          ))}
          {quietRules.map((label) => (
            <span key={label} className="quiet">
              ○ {label}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
